import Stylus from './Stylus';
import MindMapDrawingBrush from './MindMapDrawingBrush';
import styles from '../styles.module.css';
import type WhiteboardController from '../controllers/WhiteboardController';
import { type MindMapSides } from '../objects/MindMap';
import { type MindMapThemeNames } from '../objects/MindMapThemes';
import verticalIcon from '../assets/icons/shapeMindMapVertical.svg';
import horizontalIcon from '../assets/icons/shapeMindMapHorizontal.svg';
import { svgToIcon } from '../utils/svg';
import { labeledMenuComponent } from '../utils/stylus';

export interface StylusMindMapOptions {
  controller: WhiteboardController;
  sides?: MindMapSides[];
  theme?: MindMapThemeNames;
}

class StylusMindMap extends Stylus {
  sides: MindMapSides[];
  theme: MindMapThemeNames;

  constructor({
    controller,
    sides = ['east', 'west'],
    theme = 'rainbow',
  }: StylusMindMapOptions) {
    super({ controller });
    this.sides = sides;
    this.theme = theme;
  }

  get isHorizontal() {
    return this.sides.join('-') === 'east-west';
  }

  activate() {
    const brush = new MindMapDrawingBrush(this.controller.canvas, this);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  stylusId() {
    return `mindmap-${this.sides.join('-')}-${this.theme.toString()}`;
  }

  testid() {
    return super.testid() + `-${this.sides.join('-')}-${this.theme.toString()}`;
  }

  description() {
    return 'Mind map';
  }

  renderIcon() {
    const icon = this.isHorizontal ? horizontalIcon : verticalIcon;
    return svgToIcon(icon);
  }

  menuComponent() {
    return labeledMenuComponent(this.renderIcon(), this.description());
  }

  toolButtonClass() {
    return styles.labeledToolButton;
  }
}

export default StylusMindMap;
